module.exports = __webpack_public_path__ + "img/1.5eda0255.jpg";